import React from "react";
import { Button } from "../..";
import { Modal } from "react-bootstrap";
import { CompletedReviewFilterModalProps, CompletedReviewFilter, CompletedReviewFilterModalForm } from "./types";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { FormProvider, useForm } from "react-hook-form";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { ClientProjectProvider } from "../../../hooks/ClientProjectContext";
import { CompletedReviewsDefaultFilters } from "../../../hooks/FilterContext";
import ThemedModal from "../../utilities/ThemedModal";
import { CompletedReviewFilterForm } from "./form";


const CompletedReviewFiltersModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultFilters,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<CompletedReviewFilterModalProps>) => {

    const [bodyAnimation] = useAutoAnimate();
    const formMethods = useForm<CompletedReviewFilterModalForm>();
    const { handleSubmit, reset } = formMethods;

    const onClose = () => cancel!();

    const onClearFilters = () => proceed!({ ...defaultFilters, searchTerm: "" });

    const onSubmit = (form: CompletedReviewFilterModalForm) => proceed!(form);

    // whenever the default values change/we basically open the modal here.
    React.useEffect(() => {
        if (!defaultValues) {
            return;
        }
        reset({ ...defaultValues });
    }, [ defaultValues ]);

 return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Completed Review Filters</Modal.Title>
            </ThemedModal.Header>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body ref={bodyAnimation}>
                        <CompletedReviewFilterForm  />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="warning" type="button" onClick={onClearFilters}>Clear Filters</Button>
                        <Button variant="success" type="submit">Apply Filters</Button>
                        <Button variant="light" type="button" onClick={onClose}>Cancel</Button>
                    </Modal.Footer>
                </form>
            </FormProvider>
        </Modal>
    );
}

export function openCompletedReviewFiltersModal(filters: CompletedReviewFilter) {
    return createConfirmation<CompletedReviewFilterModalProps, CompletedReviewFilterModalForm>(confirmable((props) => {
        return <CompletedReviewFiltersModal {...props} />
    }))({
        dialogId: 'completed_review_filter_modal',
        defaultValues: { ...filters },
        defaultFilters: CompletedReviewsDefaultFilters
    });
}